import React from "react";
import MaterialModal from "components/modal/MaterialModal";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

/* 문의하기 모달 */
const InquireModal = ({ modalVisible, closeModal, handleModalOkButton, title, setTitle, content, setContent }) => {
  return (
    <MaterialModal open={modalVisible} closeModal={closeModal}>
      <div className="popup-content m-0 modal-width-180">
        <div className="popup-header">
          <IconButton aria-label="close" className="w-15 h-15" onClick={closeModal}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="popup-body flex flex-col justify-center items-center">
          <h5 className="text-primary font-gmarket-medium text-2xl font-bold mb-4">문의하기</h5>
          <div className="w-full">
            <TextField
              label="제목"
              placeholder="문의 제목을 입력하세요"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              className="mt-4 w-full"
            />
          </div>
          <div className="w-full py-3">
            <TextField
              label="내용"
              placeholder="문의 내용을 입력하세요"
              fullWidth
              value={content}
              onChange={(e) => setContent(e.target.value)}
              multiline
              rows={8}
              className="mt-4 w-full"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </div>
        <div className="popup-footer center">
          <button type="button" className="btn  btn-modal-o w-2/5" onClick={() => handleModalOkButton()}>
            보내기
          </button>
        </div>
      </div>
    </MaterialModal>
  );
};

export default InquireModal;
